// extracted by mini-css-extract-plugin
export default {"mask":"mask___SIVN8","content":"content___WfGJ6","text":"text___gNgR_","btn":"btn___h9r6l","close-btn":"close-btn___YcJmK"};